import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Check if we should use Clerk
const shouldUseClerk = navigator.onLine && process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Simple ClerkProvider wrapper
const ClerkProvider = shouldUseClerk ? React.lazy(() => import('@clerk/clerk-react').then(({ ClerkProvider: Provider }) => ({ default: Provider }))) : null;

// Main app wrapper
const AppWrapper = () => {
  const app = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Show offline app if no internet connection
  if (!navigator.onLine) {
    return <OfflineApp />;
  }

  // If Clerk should be used, wrap with it
  if (ClerkProvider && shouldUseClerk) {
    return React.createElement(React.Suspense, {
      fallback: React.createElement('div', { className: 'flex items-center justify-center min-h-screen bg-gray-50' },
        React.createElement('div', { className: 'animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500 mx-auto mb-4' })
      )
    }, React.createElement(ClerkProvider, {
      publishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,
      domain: process.env.REACT_APP_CLERK_DOMAIN,
      afterSignOutUrl: "/"
    }, app));
  }

  // Otherwise just return the app
  return app;
};

// Fallback component when offline or Clerk is not available
const OfflineApp = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center p-8 max-w-md">
      <div className="text-6xl mb-4">📱</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">You are offline</h1>
      <button
        onClick={() => window.location.reload()}
        className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
      >
        Try Again
      </button>
    </div>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppWrapper />);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content available, show update prompt
              if (window.confirm('New version available! Reload to update?')) {
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// PWA install handling is now managed by PWAInstallPrompt and PWAInstallButton components

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
